import {useFloatingHeader} from '@logistics-frontend/utils/hooks'
import clsx from 'clsx'
import React, {useRef} from 'react'

import * as classes from './FloatingBox.classes'

type Props = React.PropsWithChildren<{
  className?: string
  stickyTo: 'top' | 'bottom'
}>

export function FloatingBox({children, className, stickyTo = 'top'}: Props): React.ReactElement<Props> {
  const ref = useRef<HTMLDivElement>(null)
  const isFloating = useFloatingHeader(ref)

  return (
    <>
      {stickyTo === 'top' && <div ref={ref} />}
      <div className={clsx(className, classes.floating, {[classes[stickyTo]]: isFloating})}>{children}</div>
      {stickyTo === 'bottom' && <div ref={ref} />}
    </>
  )
}
